export default __webpack_public_path__ + "static/MEES_Thumb-27aa0b756673682cb21d52079b52f398.png";